/**
 * The `Deferred` class is a structure that represents a promise that can be
 * resolved or rejected at a later time. It exposes the underlying promise
 * through the `promise` property.
 *
 * @template T The type of value that this promise will resolve with.
 *
 * @example
 *  const deferred = new Deferred<TestType>();
 *  const promise = deferred.promise;
 *  deferred.resolve(myValue);
 */

export class Deferred<T = unknown, E = unknown> {
  promise: Promise<T>;

  constructor() {
    this.promise = new Promise((resolve, reject) => {
      this.reject = reject;
      this.resolve = resolve;
    });
  }

  reject: (value: E) => void = () => undefined;

  resolve: (value: T) => void = () => undefined;
}
